@if (isLoggedIn === false) {
  <div class="container-fluid h-100 d-flex justify-content-center align-items-center"
    >
    <div class="row justify-content-center align-items-center">
      <h1>Please click the link above to sign in</h1>
    </div>
  </div>
}
